import React from 'react';
import Carousel from '../carousel/carousel';
import HomeIcon from '../common/HomeIcon';
import Mantra_3_A1_Share from '../Mantra3/Mantra_3_A1_Share';
import Mantra33_2 from './manrta33_2';
import Mantra33_6 from "./mantra33_6";
import { imgUrl } from "../../utils/url";
import TableTd from './TableTd';
import SharePrintIcon from '../common/SharePrintIcon';
import WallList from '../common/WallList';




class Mantra33_1 extends React.Component {
    constructor() {
        super()
        this.state = {
            star: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            form: false,
            showCanvas: false,
            img: null,
            id: null,
            table: {
                "No": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], "PARAMETERS": ['Approachable', 'Cool quotient', 'Sporty', 'Compassionate',
                    'Patient', 'Calm in Crisis', 'Fun-loving', 'Positivity', 'Tech Awareness', 'Role Model'], "RATING": [10, 10, 10, 10, 10, 10, 10, 10, 10, 10]
            },
            showDownloadAndEmail: false,
            bckBttn: false
        }
    }
    setForm = () => {
        this.setState({ form: true, bckBttn: true  })
    }

    onCanVase = (img, id) => {
        this.setState({ showCanvas: true, form: false, img, id })
    }

    showDownload = () => {
        this.setState({
            showDownloadAndEmail: true,
            form: false
        })
    }

    backToForm = () => {
        this.setState({ form: false, bckBttn: false });
      }

    render() {
        const { table, star, img, form, id, showDownloadAndEmail, bckBttn } = this.state;
        let keys = Object.keys(table);
        const { pageData, module_name } = this.props;
        let image = pageData.template_url ? imgUrl + pageData.template_url : "";
        let text = pageData.description ? pageData.description : "";
        return (
            <div>
                {/* <Carousel /> */}
                {/* <img src="/assets/img/home.png" className="img-fluid mantr6_img" alt="" /> */}
                {
                    form ? <Mantra33_2 {...this.props} onCanVase={this.onCanVase} bckBttn={bckBttn} backToForm={this.backToForm} /> :
                        !this.state.showCanvas && !showDownloadAndEmail && <>
                            <HomeIcon />
                            <div className="container">
                                <div className="mantra33_upload_div">
                                    <SharePrintIcon pageData={this.props.pageData} image={image} text={text} id={module_name} />
                                    <img src="/assets/img/userdefault.png" className="img-fluid d-block mx-auto user_img" alt="" />
                                    <img src="/assets/img/multistar.png" className="img-fluid multistar_img" alt="" />
                                    <div className="inpu_m33">
                                        <img src="/assets/img/camera.png" className="img-fluid change_img" alt="" />

                                    </div>

                                </div>
                                <div className="upload_heading">
                                    <h5>Upload your parent’s photo</h5>
                                </div>



                                <table className="table table-bordered table_class">
                                    <thead>
                                        {/* <tr>
                                            {keys && keys.length > 0 && keys.map((val, index) => {
                                                return (
                                                    <th key={index} className="serail_bg">{val}</th>
                                                )
                                            })}
                                        </tr> */}
                                        <tr>
                                            <th className="serail_bg">No</th>
                                            <th className="parameter_bg">PARAMETERS</th>
                                            <th className="rating_bg">RATING</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {

                                            table['No'] && (table['No']).length > 0 && (table['No']).map((val, index1) => {

                                                return (
                                                    <tr key={index1}>
                                                        <td>{table['No'][(index1)]}</td>
                                                        <td>{table['PARAMETERS'][(index1)]}</td>
                                                        <td>
                                                            <ul className={"star_rating star_" + (index1 + 1)}>
                                                                {
                                                                    star && star.map((val, key2) => {
                                                                        let classactive = '';
                                                                        return (
                                                                            <li className={classactive} key={key2}>&nbsp;</li>
                                                                        )
                                                                    })
                                                                }
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                )
                                            })

                                        }
                                    </tbody>
                                </table>

                                <div className="total_score">
                                    <h6>TOTAL SCORE <span>0</span>/100</h6>
                                </div>

                                <div className="preview_btn">
                                    <button type="button" className="share2_btn" onClick={() => { this.setForm() }}>Fill &amp; Share</button>
                                    <p style={{ textAlign: 'center' }}>Or</p>
                                    <button type="button" className="share2_btn" onClick={this.showDownload} >Download / Email</button>
                                </div>
                            </div>
                        </>
                }

                {
                    showDownloadAndEmail && (
                        <Mantra33_6 pageData={this.props.pageData} img={img} id={id} module_name={module_name}  />
                    )
                }

                {
                    this.state.showCanvas && img && <Mantra_3_A1_Share pageData={this.props.pageData} img={img} id={id} />
                }

                <WallList module_name={this.props.module_name} type={this.props.type} />
            </div>
        )
    }

}

export default Mantra33_1;